import { tr } from 'mmfintech-commons'
import CrossIcon from '@assets/icons/cross.svg?react'
import { breakpoints } from '@constants'
import cn from 'classnames'
import {
  isOwnerOrAdministrator,
  MerchantEntityTypes,
  selectCurrentUserRole,
  selectMerchantEntityType,
  useAppSelector
} from 'mmfintech-backend-api'
import { GlobalContext, useDropDownMenu, useMatchMedia } from 'mmfintech-commons'
import { useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { usePaymentButtons } from './usePaymentButtons'

export const PaymentButtonsMobile = ({ isOpenDropDown, rowHeight }) => {
  const { modalShow } = useContext(GlobalContext)

  const history = useHistory()
  const { pathname } = useLocation()

  const isLarge = useMatchMedia({ breakpoint: breakpoints.xl, prefix: 'max' })

  const dropDown = useDropDownMenu()
  const customerRole = useAppSelector(selectCurrentUserRole)
  const entityType = useAppSelector(selectMerchantEntityType)

  const buttons = usePaymentButtons(isOwnerOrAdministrator(customerRole), entityType === MerchantEntityTypes.COMPANY)

  // Clashes with the ticket list pagination / compose bar on /support pages
  // (fixed position, always sits near the bottom-center of the viewport
  // regardless of page content) — hide it there, same pattern SupportFab.tsx
  // already uses for its own FAB.
  if (pathname.startsWith('/support')) return null

  return (
    <div style={{ zIndex: isOpenDropDown ? '106' : '110' }} className='header-mobile-payment-buttons-wrapper'>
      <div
        className={cn('header-mobile-background-shadow', {
          visible: dropDown.visible
        })}
      ></div>
      <div
        onClick={e => {
          e.stopPropagation()
          dropDown.toggleDropDown()
        }}
        className={cn('header-mobile-payment-buttons', {
          visible: dropDown.visible
        })}
      >
        <div
          data-for={`payment-button-menu`}
          data-tip={tr('FRONTEND.COMMON.QUICK_ACTIONS', 'Quick actions')}
          className='payment-icon-wrapper'
        >
          <div className='payment-icon'>
            <CrossIcon />
          </div>
          {isLarge && (
            <ReactTooltip
              id={`payment-button-menu`}
              textColor='black'
              backgroundColor='white'
              effect='solid'
              className='custom-tool-tip-component'
              padding='8px 6px'
              place={'left'}
            >
              {tr('FRONTEND.PAYMENT_BUTTONS_MOBILE.QUICK_ACTIONS', 'Quick Actions')}
            </ReactTooltip>
          )}
        </div>
        <div
          className='payment-dropdown'
          style={{
            height: `${dropDown.visible ? buttons.length * rowHeight + 110 : 0}px`,
            top: `${dropDown.visible ? `-${buttons.length * 68 + 60}px` : 0} `
          }}
        >
          {buttons.map(button => (
            <div
              key={button.label}
              onClick={() => (button?.path ? history.push(button.path) : button.func(modalShow))}
              className={cn('payment-button', { visible: dropDown.visible })}
            >
              {button.icon}
              <p>{button.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
